import type { ThemeType } from "../enums";

export const ThemeTypeOptions: { value: ThemeType; label: string }[] = [
  { value: "Gradient", label: "Gradient" },
  { value: "SolidColor", label: "Solid Color" },
];
